"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _subscribeToBackInStockMutation = require("./subscribeToBackInStockMutation");
Object.keys(_subscribeToBackInStockMutation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _subscribeToBackInStockMutation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _subscribeToBackInStockMutation[key];
    }
  });
});
